import { render, staticRenderFns } from "./Curriculum-form.vue?vue&type=template&id=7dcb522b&scoped=true"
import script from "./Curriculum-form.vue?vue&type=script&lang=js"
export * from "./Curriculum-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcb522b",
  null
  
)

export default component.exports